import { MainLangType } from 'types/mainPage';
import { localizedTexts } from 'utils/constantNames';

export const LanguageService = {
  getLanguage(): MainLangType {
    return <MainLangType>localStorage.getItem('lang') || 'ru';
  },
  setLanguage(lang: string): void {
    localStorage.setItem('lang', lang);
  },
};

export function getText(key: string): string {
  const lang = LanguageService.getLanguage();
  return localizedTexts[lang][key];
}
